module.exports = __webpack_public_path__ + "static/media/levelUp_1.597af90a.mp3";